var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchdirections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#399CDB",
    fillRule: "nonzero",
    d: "M15.812 17.628l4.125-.003-6 6.375-6-6.375h4.125V7.5h3.75v10.128zM7.938 6.372V16.5h-3.75V6.375H.062l6-6.375 6 6.375-4.124-.003z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchdirections);
export default __webpack_public_path__ + "static/media/switchdirections.c408cfb5b4a9bab59829826bb3281cf9.svg";
export { ForwardRef as ReactComponent };